var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coinsKrwOpen === '1')?_c('krwManagement'):(_vm.coinsKrwOpen === '0')?_c('UserManagement'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }